import { SkeletonText, Space, Text } from '@billy/design-system'
import React, { ReactElement, useLayoutEffect, useRef } from 'react'

import { DateFormatter } from '../../../TableCellFormatters'
import { HIGHLIGHT_NOTE_CLASS_NAME } from '../../constants/highlightNoteClassName'
import { Note } from '../../types/note'
import * as Styled from './styles'

interface NoteItemProps {
  note?: Note
  isNew?: boolean
  isLoading?: boolean
}

export const NoteItem = ({ note, isLoading, isNew }: NoteItemProps): ReactElement => {
  const wrapperRef = useRef<HTMLLIElement>(null)

  useLayoutEffect(() => {
    if (isNew && wrapperRef.current) {
      wrapperRef.current.classList.add(HIGHLIGHT_NOTE_CLASS_NAME)
    }
  }, [isNew])

  const noteDate = note?.date ? (
    <Styled.NoteDateWrapper>
      <Text variant="bodySM" colorVariant="placeholder">
        <DateFormatter value={note.date} dateFormat="MMM. d yyyy" />
      </Text>
    </Styled.NoteDateWrapper>
  ) : (
    '—'
  )

  const noteAuthor = note?.author ? (
    <Text variant="bodySM" weight="medium" colorVariant="placeholder" title={note.author} truncate>
      {note.author}
    </Text>
  ) : (
    '—'
  )

  return (
    <Styled.NoteItemWrapper ref={wrapperRef}>
      <Styled.NoteHeader>
        {isLoading ? <SkeletonText variant="bodySM" width={70} /> : noteDate}
        <Styled.NoteAuthorWrapper>
          {isLoading ? <SkeletonText variant="bodySM" width={70} /> : noteAuthor}
        </Styled.NoteAuthorWrapper>
      </Styled.NoteHeader>
      <Space size="s4" />
      <Styled.NoteContent>
        {isLoading ? (
          <>
            <SkeletonText fullWidth />
            <Space size="s4" />
            <SkeletonText width={200} />
            <Space size="s4" />
            <SkeletonText fullWidth />
          </>
        ) : (
          <Text>{note?.description}</Text>
        )}
      </Styled.NoteContent>
    </Styled.NoteItemWrapper>
  )
}
